import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import FlagType from 'owa-service/lib/contract/FlagType';

/**
 * Handler for setting flag status the rows
 */
export type setRowsFlagStateInternalHandler = (
    rowKeys: string[],
    flagTypeToApply: FlagType
) => void;

export default function setRowsFlagStateHelper(
    itemRowKeys: string[],
    tableViewId: string,
    flagTypeToApply: FlagType,
    setRowsFlagStateInternal: setRowsFlagStateInternalHandler,
    override?: boolean
) {
    if (override) {
        setRowsFlagStateInternal(itemRowKeys, flagTypeToApply);
        return;
    }
    const tableView = listViewStore.tableViews.get(tableViewId);

    // Filter out the rows which has the same flag type as the new flag type
    const filteredRowKeys = itemRowKeys.filter(
        rowKey =>
            MailRowDataPropertyGetter.getFlagStatus(rowKey, tableView) != flagTypeToApply.FlagStatus
    );

    if (filteredRowKeys.length == 0) {
        // Nothing to set flag status on
        return;
    }
    setRowsFlagStateInternal(filteredRowKeys, flagTypeToApply);
}
